import React from "react";
import PropTypes from "prop-types";
import StyledFilterPriceRadioEverscore from "./FilterPriceRadioEverscore.styled";
import { filterRangePT } from "../../config/prop-types";

const FilterPriceRadioEverscore = React.memo(props => {
  const { range, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterPriceRadioEverscore className={`filter-product-price__radio ${checked && "is-checked"}`}>
      <input disabled={disabled} checked={checked} onChange={() => checkFilter(range.id.toString(), range.value[0], range.value[1])} type="radio" />
      <span className="filter-product-price__radio__custom"></span>
      <span className="filter-product-price__radio__copy">{range.name}</span>
    </StyledFilterPriceRadioEverscore>
  );
});

FilterPriceRadioEverscore.propTypes = {
  range: filterRangePT.isRequired,
  checkFilter: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilterPriceRadioEverscore;